module.exports = __webpack_public_path__ + "static/media/abstract.eeda3ca2.jpg";